import intl from 'react-intl-universal';
import { FormItem, Dropdown, Typography } from '@getsynapse/design-system';
import { TimePeriodType } from 'utils/types/strategyGoals';
import { Option } from 'utils/customTypes';
import { useSelector } from 'react-redux';
import { selectYears } from 'state/YearTimePeriods/YearTimePeriodSlice';
import classnames from 'classnames';

type TimePeriodProps = {
  value?: Option[];
  isRequired?: boolean;
  onChange: (value: number | TimePeriodType, prop: string) => void;
  newGoal?: boolean;
};

const Year = ({
  value,
  onChange,
  isRequired = true,
  newGoal = false,
}: TimePeriodProps) => {
  const years = useSelector(selectYears);

  const yearOptions =
    years &&
    years.map((year) => ({
      label: year.toString(),
      value: year,
    }));
  const changeHandler = (option: Option) => {
    if (!newGoal) {
      const year = option.value;
      onChange(year, 'year');
    } else {
      onChange(option.value, 'year');
    }
  };

  return (
    <FormItem
      className={classnames('w-full', {
        'mb-4': !newGoal,
      })}
      label={intl.get('STRATEGY_GOALS.ADD_GOAL_MODAL.YEAR')}
      labelProps={{
        required: isRequired,
        'data-cy': 'time-period_label',
      }}
    >
      {isRequired && (
        <Dropdown
          options={yearOptions}
          values={value}
          onChange={changeHandler}
          triggerProps={{
            placeholder: intl.get(
              'STRATEGY_GOALS.ADD_GOAL_MODAL.YEAR_PLACEHOLDER'
            ),
            'data-testid': 'year_dropdown',
          }}
          listProps={{
            className: 'w-full',
            'data-testid': 'year_list',
          }}
        />
      )}
      {!isRequired && value?.length && (
        <Typography variant='body' data-cy='year_value'>
          {`${value[0].label}`}
        </Typography>
      )}
    </FormItem>
  );
};

export default Year;
